document.addEventListener('DOMContentLoaded', function() {
  const contentArea = document.querySelector('.eco-article__content');
  const tocContainer = document.getElementById('eco-toc-container');

  if (!contentArea || !tocContainer) return;

  // 获取所有 H2 标题（你可以根据需要加上 H3）
  const headings = contentArea.querySelectorAll('h2');
  
  if (headings.length === 0) {
    document.querySelector('.eco-toc-widget').style.display = 'none';
    return;
  }

  const ul = document.createElement('ul');

  headings.forEach((heading, index) => {
    // 给文章中的标题自动添加 ID，以便锚点跳转
    const anchorId = `toc-heading-${index}`;
    heading.id = anchorId;

    const li = document.createElement('li');
    const a = document.createElement('a');
    
    a.href = `#${anchorId}`;
    a.textContent = heading.textContent;
    
    // 平滑滚动
    a.addEventListener('click', function(e) {
      e.preventDefault();
      document.getElementById(anchorId).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    li.appendChild(a);
    ul.appendChild(li);
  });

  tocContainer.appendChild(ul);
});